import { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import xor from 'lodash/xor';
import withChat from '../Provider/withChat.js';
import { LocalConversationId } from '@deal/chat-firebase-client';

var ConversationQuery =
/** @class */
function (_super) {
  __extends(ConversationQuery, _super);

  function ConversationQuery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      loading: !!_this.props.conversationId
    };
    _this.load = _this.load.bind(_this);
    _this.cleanup = _this.cleanup.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.handleConversationChanged = _this.handleConversationChanged.bind(_this);
    return _this;
  }

  ConversationQuery.prototype.componentDidMount = function () {
    this.load();
  };

  ConversationQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available
    if (!this.props.chatClient) {
      this.cleanup();
    } // Client, ConversationId, recipient list, or authentication state has changed


    if (prevProps.chatClient !== this.props.chatClient || prevProps.conversationId !== this.props.conversationId || prevProps.authenticatedUserId !== this.props.authenticatedUserId || xor(prevProps.recipientIds || [], this.props.recipientIds || []).length > 0) {
      this.load();
    }
  };

  ConversationQuery.prototype.componentWillUnmount = function () {
    this.cleanup();
  };

  ConversationQuery.prototype.load = function () {
    var _a = this.props,
        chatClient = _a.chatClient,
        conversationId = _a.conversationId,
        recipientIds = _a.recipientIds,
        authenticatedUserId = _a.authenticatedUserId; // At a minimum we need a chat client to load the Conversation

    if (!chatClient) {
      return;
    }

    var isLocalConversationId = conversationId && LocalConversationId.isLocalConversationId(conversationId); // We also need something to look up by:
    //   For local conversations: either a set of recipients or a ConversationId
    //   For persisted conversations: just a ConversationId and an authenticated Firebase session

    if (isLocalConversationId && conversationId) {
      this.cleanup();
      this.conversation = chatClient.getConversation(conversationId);
    } else if (!isLocalConversationId && conversationId && authenticatedUserId) {
      this.cleanup();
      this.conversation = chatClient.getConversation(conversationId);
    } else if (recipientIds && recipientIds.length > 0) {
      this.cleanup();
      this.conversation = chatClient.getLocalConversationByRecipients(recipientIds);
    } else {
      this.cleanup();
      this.handleConversationChanged();
      return;
    }

    this.setState({
      loading: true
    });

    if (this.conversation.initialized) {
      this.handleConversationLoaded();
    } else {
      this.conversation.once('initialized', this.handleConversationLoaded, this);
    }

    this.conversation.on('changed', this.handleConversationChanged, this);
  };

  ConversationQuery.prototype.cleanup = function () {
    if (this.conversation) {
      this.conversation.off('initialized', this.handleConversationLoaded, this);
      this.conversation.off('changed', this.handleConversationChanged, this);
      delete this.conversation;
    }
  };

  ConversationQuery.prototype.handleConversationLoaded = function () {
    if (this.props.onCompleted) {
      this.props.onCompleted({
        conversation: this.conversation
      });
    }

    this.setState({
      loading: false
    });
  };

  ConversationQuery.prototype.handleConversationChanged = function () {
    this.forceUpdate();
  };

  ConversationQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the `query` is in flight. We also consider the conversation
     *   as being in a loading state until it is initialized. If there is no conversationId provided to
     *   the query, then it is never in a loading state.
     */
    var conversationIsLoading = this.conversation ? !this.conversation.initialized : !!this.props.conversationId;
    var loading = this.state.loading || conversationIsLoading;
    return this.props.children({
      loading: loading,
      conversation: this.conversation
    });
  };

  return ConversationQuery;
}(Component);

var ConversationQuery$1 = withChat(ConversationQuery);

export default ConversationQuery$1;
//# sourceMappingURL=index.js.map
